module.exports = __webpack_public_path__ + "img/Regelung.e8c6065d.png";